import React from 'react'
import NavTitle from '../../components/nav-title'
import TextNavTitle from '../../components/TextNavTitle'
import NavRoleOrg from '../../components/nav-role-org'
import CardCustom from '../../components/custom/card-custom'
import { Col, Row } from 'react-bootstrap'
import { Input } from 'antd'
import ReportNewPage from '../../components/employees/report/report-new'

function ReportPage() {
  return (
    <Row>
      <ReportNewPage />
    </Row>
  )
}

export default ReportPage
